'use client';

import { Bar, BarChart, CartesianGrid, XAxis } from 'recharts';

import { Card, CardContent, CardDescription, CardHeader } from '../../components/ui/card';
import { ChartConfig, ChartContainer, ChartTooltip, ChartTooltipContent } from '../../components/ui/chart';
import useAnalytics from '../../stores/useAnalytics';

const chartConfig = {
  revenue: {
    label: 'Revenue',
    color: '#131442',
  },
} satisfies ChartConfig;

export default function BarCharts() {
  const { monthlyRevenue } = useAnalytics();
  const chartData = monthlyRevenue;
  const totalRevenue = chartData.reduce((total, data) => total + data.revenue, 0);
  return (
    <Card>
      <CardHeader>
        <h3 className="text-lg md:text-2xl font-semibold">Profit </h3>
        <CardDescription>
          <p className="text-lg md:text-2xl font-bold text-black">
            {Intl.NumberFormat('id-ID', {
              style: 'currency',
              currency: 'IDR',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }).format(totalRevenue ?? 0)}
          </p>
          <p className="text-xs md:text-base lg:text-xl">
            Total net profit of all invoices issued in the year {new Date().getFullYear()}
          </p>
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ChartContainer config={chartConfig} className="lg:h-[60dvh] w-full">
          <BarChart accessibilityLayer data={chartData}>
            <CartesianGrid vertical={false} />
            <XAxis
              dataKey="month"
              tickLine={false}
              tickMargin={10}
              axisLine={false}
              tickFormatter={(value) => value.slice(0, 3)}
            />
            <ChartTooltip cursor={false} content={<ChartTooltipContent />} />
            <Bar dataKey="revenue" fill="var(--color-revenue)" radius={8} />
          </BarChart>
        </ChartContainer>
      </CardContent>
    </Card>
  );
}
